"use client";

import { useEffect, useRef, useState } from "react";

import { CheckIcon } from "@/components/appIcons";
import { useCurrency } from "@/hooks/use-currency";
import { USER_SELECTABLE_CURRENCIES } from "@garimpa/lib/currencies";

export function CurrencySelector() {
  const { currency, setCurrency, isPending } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  function handleSelect(code: string) {
    if (code === currency) {
      setOpen(false);
      return;
    }
    setOpen(false);
    setCurrency(code);
  }

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        disabled={isPending}
        className="relative after:absolute after:-inset-1.5 after:content-[''] flex items-center justify-center rounded-lg size-8 text-xs font-bold text-muted-foreground hover:text-foreground transition-colors"
      >
        {currency}
      </button>

      {open && (
        <ul className="absolute right-0 bottom-full mb-1 w-max rounded-lg border border-border bg-card shadow-lg py-1 z-50">
          {USER_SELECTABLE_CURRENCIES.map((c) => (
            <li key={c.code}>
              <button
                onClick={() => handleSelect(c.code)}
                className="flex items-center gap-2 w-full px-3 py-2 text-sm hover:bg-primary/10 transition-colors"
              >
                <span className="w-6 text-right font-medium text-muted-foreground">{c.symbol}</span>
                <span>{c.name}</span>
                {c.code === currency && <CheckIcon className="text-base ml-auto" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
